import type { SxProps, Theme } from "@mui/material";
import { baseTheme } from "../../themes/shipinsure";

const { status } = baseTheme.colors;

export const statusColors = status;

export const statusPanelSx = (emphasized = false): SxProps<Theme> => ({
  border: emphasized
    ? `1px solid ${baseTheme.colors.primary}`
    : `1px solid ${status.panelBorder}`,
  borderRadius: "12px",
  padding: "16px",
  backgroundColor: emphasized
    ? status.panelHighlightBg
    : baseTheme.colors.neutral,
});

export const statusSectionTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: "1.05rem",
  color: baseTheme.colors.text,
};
